import React, { useEffect } from "react";
import { Alert, Card, Spinner } from "react-bootstrap";
import { useSuperState } from "helpers/hooks";
import { QueueHistoryProvider, QueueHistoryTable } from "pages/dashboard/queue/tabs/history";
import { useApp } from "common/context";
import Pager from 'common/components/Pager';
import { FormattedMessage } from "react-intl";
import { ActiveQueueTable } from "../active";

export const QueueHistory = props => {

    const { api } = useApp();

    const [state, setState] = useSuperState({
        loading: true,
        error: null,
        entries: [],
        count: 0,
        appstream_fleet_name: null,
        page: 1,
        page_size: 20,
        search: ''
    });

    const { loading, error, entries, appstream_fleet_name, count, page, page_size, search } = state;

    const clearError = () => setState({ error: null });

    const handleChangePage = page => setState({ page, entries: [] });

    const fetchQueueHistory = async () => {

        try {

            setState({ loading: true });

            const { page, page_size } = state;

            const { entries, count } = await api.get(`/api/appstream/queue/history/list/${page}/${page_size}`, { appstream_fleet_name });
            setState({
                entries,
                count,
                loading: false
            });

        } catch (e){

            const error = e?.err || e?.message || e;
            setState({
                loading: false,
                error
            });

        }

    };

    useEffect(() => {

        (async() => {
            await fetchQueueHistory();
        })();

    }, [page, page_size, appstream_fleet_name, search]);

    const context = {
        entries,
        appstream_fleet_name,
        loading
    };

    return (
        <QueueHistoryProvider value={context}>
            <div className="queue-history d-flex flex-column gap-3">

                <Alert variant="danger" dismissible show={!!error} onClose={clearError}>
                    {error}
                </Alert>

                <Card>
                    <Card.Body>
                        {loading ?
                            (
                                <div className="text-center">
                                    <Spinner animation="border" role="status">
                                        <span className="visually-hidden">
                                            <FormattedMessage
                                                defaultMessage="Loading..."
                                                id="label.loading"
                                            />
                                        </span>
                                    </Spinner>
                                </div>
                            )
                            :
                            (
                                <QueueHistoryTable/>
                            )
                        }

                    </Card.Body>
                </Card>
                <Pager
                    page={page}
                    count={count}
                    page_size={page_size}
                    onChange={handleChangePage}
                />
            </div>
        </QueueHistoryProvider>
    );
};